import styled from 'styled-components';
export const GinStepRichTextContentContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding-bottom: ${({ theme }) => theme.spacing.sm}px;
`;
export const GinStepRichTextContentContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
`;
